// Path: ./src/app/pages/CreateFlyerItemListPage/CreateFlyerItemListModal/styled.ts
import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: start;
  flex-wrap: wrap;
  padding: 15px 16px 10px 16px;
`;

export const SubmitButtonWrapper = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;

  @media (max-width: 649px) {
    justify-content: center;
  }
`;
export const SubmitButton = styled.div`
  width: 78px;
  background-color: #ff8038;
  height: 40px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  cursor: pointer;
  @media (max-width: 649px) {
    margin-top: 10px;
    width: 100%;
  }
`;

interface DateButtonProps {
  isSelected?: boolean;
}
export const DateButton = styled.button<DateButtonProps>`
  width: 164px;
  height: 44px;
  background: ${({ isSelected }) =>
    isSelected
      ? "#f58220  0% 0% no-repeat padding-box"
      : "#ffffff 0% 0% no-repeat padding-box"};
  border: 3px solid #f58220;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;

  font-weight: 600;

  color: ${({ isSelected }) => (isSelected ? "white" : "#00000092")};
  &:hover {
    background: #f58220 0% 0% no-repeat padding-box;
    color: white;
  }
`;
export const DateSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  margin-top: 20px;
  max-width: 712px;
  @media (max-width: 590px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export const DateButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  @media (max-width: 631px) {
    justify-content: center;
  }
`;

export const StoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const TitleCss = `
  font: normal normal bold 28px/50px Greycliff CF;
  letter-spacing: 0px;
  color: #0b0b0b;
  text-transform: capitalize;
`;

export const WrapperCss = `
margin-left:10px;
margin-top:10px;
width:100%;
max-width: 664px;
`;

export const inputCss = `
width:100%;
max-width: 664px;
min-width:300px;
`;
